module.exports = __webpack_public_path__ + "img/hole.cf268083.svg";